import { useSearchParams } from "react-router";
import { useCallback } from "react";
import { ListType } from "@/shared/ui/ListTypeSwitch";

export const useListType = (defaultListType: ListType = "grid") => {
  const [searchParams, setSearchParams] = useSearchParams();

  const view = (searchParams.get("view") as ListType) || defaultListType;

  const setListType = useCallback(
    (newListType: ListType) => {
      setSearchParams((prev) => {
        prev.set("view", newListType);
        return prev;
      });
    },
    [setSearchParams]
  );

  return {
    view,
    setListType,
  };
};
